import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requestConfig from 'app/requests/ServiceCenter/ServiceCenterMonitoring.requests'
import {
    TruckCapacity,
} from '../serviceCenters.types'

const useGetTruckCapacity = ({
    serviceCenter,
}: {
    serviceCenter: {id: number}
}) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useRequest<TruckCapacity>({
        key: RequestKeys.getTruckCapacity,
        params: {
            params: {
                serviceCenter,
            },
        },
        requestFunc: RequestFn.getEntity(requestConfig.getTruckCapacity),
        enabled: Boolean(serviceCenter?.id),
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}

export default useGetTruckCapacity
